import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { key: 5 }
const _hoisted_6 = { key: 6 }
const _hoisted_7 = { key: 7 }

import {OccupationtRef} from '@/logic/workspaces/tickets/_def' //C:\Work\mailnum\web.mn\src\logic\workspaces\tickets\_def.ts

//Components

import TodoTitleComponent from '@/components/Workspaces/todos/_spec/TodoTitleComponent.vue';
import { Category } from '@/logic/workspaces/persons/_def';


export default /*#__PURE__*/_defineComponent({
  __name: 'EffortTitleComponent',
  props: {
    effort: {}
  },
  setup(__props: any) {


const props = __props


return (_ctx: any,_cache: any) => {
  return (_ctx.effort.ticket != null)
    ? (_openBlock(), _createBlock(TodoTitleComponent, {
        key: 0,
        model: _ctx.effort,
        active: false
      }, null, 8, ["model"]))
    : (_ctx.effort.category == _unref(Category).N)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.effort.title), 1))
      : (_ctx.effort.category == _unref(Category).M)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Meeting"))
        : (_ctx.effort.category == _unref(Category).I)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Idle"))
          : (_ctx.effort.category == _unref(Category).L)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Langoliered"))
            : (_ctx.effort.category == _unref(Category).X)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Forcemajour"))
              : (_ctx.effort.category == _unref(Category).P)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Intertask/Planning"))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.effort.category), 1))
}
}

})